<template>
  <div id="hospitalRanking">
    <div class="bg-color-black">
      <div class="title-box">
        <div class="title">报废织物排行</div>
        <div class="tab-switch">
          <span :class="['tab-item', { active: dateType === 'month' }]" @click="switchDateType('month')">月</span>
          <span :class="['tab-item', { active: dateType === 'year' }]" @click="switchDateType('year')">年</span>
        </div>
      </div>

      <div class="table-header">
        <div class="col-rank">排名</div>
        <div class="col-name">织物名称</div>
        <div class="col-count">报废数量</div>
        <div class="col-life">洗涤次数</div>
      </div>

      <div
        class="table-body"
        :style="{ height: `${visibleRows * rowHeight}px` }"
        ref="tableBody"
        @mouseenter="stopScroll"
        @mouseleave="startScroll"
      >
        <div class="scroll-wrapper" :class="{ scrolling: isScrolling }">
          <div class="scroll-content">
            <div v-for="(item, index) in displayData" :key="`${item.spuId || index}-a-${index}`" class="table-row">
              <div class="col-rank">
                <span :class="['rank-num', { topThree: index < 3 }]">{{ index + 1 }}</span>
              </div>
              <div class="col-name" :title="item.spuName">{{ item.spuName || '-' }}</div>
              <div class="col-count">{{ item.num || 0 }}</div>
              <div class="col-life">{{ item.numWashing || 0 }}次</div>
            </div>
          </div>
          <div class="scroll-content copy" v-if="displayData.length > 0">
            <div v-for="(item, index) in displayData" :key="`${item.spuId || index}-b-${index}`" class="table-row">
              <div class="col-rank">
                <span :class="['rank-num', { topThree: index < 3 }]">{{ index + 1 }}</span>
              </div>
              <div class="col-name" :title="item.spuName">{{ item.spuName || '-' }}</div>
              <div class="col-count">{{ item.num || 0 }}</div>
              <div class="col-life">{{ item.numWashing || 0 }}次</div>
            </div>
          </div>
        </div>
        <div v-if="displayData.length === 0" class="empty-tip">暂无数据</div>
      </div>

      <div class="total-box">
        <span class="total-label">报废总数：</span>
        <span class="total-num">{{ totalCount }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "@/api/index";
import { sortArrayByKey } from "../../utils";

export default {
  data() {
    return {
      dateType: "month",
      displayData: [],
      totalCount: 0,
      params: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
      },
      intervalId: null,
      isScrolling: false,
      animationFrameId: null,
      scrollPosition: 0,
      scrollStep: 0.12,
      rowHeight: 35,
      visibleRows: 3,
    };
  },
  mounted() {
    this.getData();
    this.intervalId = setInterval(() => {
      this.getData();
    }, 30 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.stopScroll();
  },
  methods: {
    switchDateType(type) {
      this.dateType = type;
      this.getData();
    },
    stopScroll() {
      this.isScrolling = false;
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },
    startScroll() {
      if (this.displayData.length <= this.visibleRows) return;
      this.isScrolling = true;
      this.scrollPosition = 0;
      this.animate();
    },
    animate() {
      if (!this.isScrolling) return;
      this.scrollPosition += this.scrollStep;
      const totalHeight = this.displayData.length * this.rowHeight;
      if (this.scrollPosition >= totalHeight) {
        this.scrollPosition = 0;
      }
      const scrollContent = this.$refs.tableBody?.querySelector(".scroll-wrapper");
      if (scrollContent) {
        scrollContent.style.transform = `translateY(-${this.scrollPosition}px)`;
      }
      this.animationFrameId = requestAnimationFrame(() => this.animate());
    },
    async getData() {
      const req = {
        year: this.params.year,
        dateType: this.dateType,
        "tenant-id": this.$route.query.customerId,
      };
      if (this.dateType === "month") {
        req.month = this.params.month;
      }

      const res = await api.getBigSkuDisposeNew(req);
      if (res.ResultCode !== 0) return;

      const rawData = res.Result?.list || [];
      this.totalCount = res.Result?.totalNum || 0;

      const sorted = sortArrayByKey(rawData, "num").slice(0, 100);
      this.displayData = sorted;

      this.$nextTick(() => {
        this.stopScroll();
        this.startScroll();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#hospitalRanking {
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;

  .bg-color-black {
    height: 100%;
    padding: 0 16px 10px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }

  .title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    padding-top: 10px;
    padding-bottom: 6px;
    flex-shrink: 0;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      color: #00cdff;
    }
  }

  .tab-switch {
    display: flex;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
    overflow: hidden;

    .tab-item {
      padding: 6px 16px;
      font-size: 14px;
      color: #8e9eae;
      cursor: pointer;

      &.active {
        background: #409eff;
        color: #fff;
      }
    }
  }

  .table-header {
    display: flex;
    flex-shrink: 0;
    height: 40px;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    font-size: 14px;
    color: #8e9eae;
    box-sizing: border-box;
  }

  .table-body {
    flex-shrink: 0;
    min-height: 0;
    overflow: hidden !important;
    position: relative;
    box-sizing: border-box;

    .scroll-wrapper {
      will-change: transform;
      width: 100%;
    }

    .table-row {
      display: flex;
      height: 42px;
      line-height: 42px;
      padding: 0;
      border-bottom: 1px solid rgba(255, 255, 255, 0.05);
      font-size: 14px;
      color: #fff;
    }

    .empty-tip {
      text-align: center;
      padding: 30px 0;
      color: #8e9eae;
      font-size: 14px;
    }
  }

  .total-box {
    height: 36px;
    padding: 8px 0;
    margin: 8px 0 0;
    border-radius: 4px;
    text-align: center;
    flex-shrink: 0;
    background: rgba(64, 158, 255, 0.12);
    box-sizing: border-box;

    .total-label,
    .total-num {
      color: #409eff;
      font-size: 14px;
    }

    .total-num {
      margin-left: 6px;
      font-weight: 700;
    }
  }

  .col-rank {
    width: 16%;
    text-align: center;

    .rank-num {
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.12);

      &.topThree {
        background: #409eff;
      }
    }
  }

  .col-name {
    width: 38%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .col-count {
    width: 22%;
    text-align: center;
    color: #f56c6c;
  }

  .col-life {
    width: 24%;
    text-align: center;
    color: #e6a23c;
  }
}
</style>

